<template>
	<div class="floor-container">
		<div class="flex-center floor-first">
			<div>地址：黑龙江省哈尔滨市南岗区红军街75号</div>
			<div style="margin: 0 30px;">联系电话：19524511118</div>
			<div>联系邮箱：3973401180@qq.com</div>
		</div>
		<div class="copyright" style="width: 100%;;padding-top: 20px;text-align: center;">
			Copyright © 2024 实践教学智慧平台 版权所有 | <a href="https://beian.miit.gov.cn/" target="_blank" style="color: #333;text-decoration: none;">沪ICP备2021028823号</a> 
		</div>
	</div>
</template>

<script>
	import {
		fileUrl
	} from '@/common/config'
	import {
		EventBus
	} from '@/utils/event-bus';
	export default {
		name: '',
		props: {

		},
		components: {

		},
		data() {
			return {
				
			}
		},
		created() {
		
		},
		mounted() {

		},
		
		methods: {
			
		}

	}
</script>

<style lang="scss" scoped>
	.floor-container {
		width: 100%;
		padding: 0;
		font-size: .9375vw;
	}
	// 响应式
	
	@media screen and (min-width: 1200px) {}
	
	@media screen and (min-width: 923px) and (max-width:1199px) {}
	
	@media screen and (min-width: 768px) and (max-width:922px) {}
	
	@media screen and (max-width: 922px) {
		.floor-container {
			padding: 0 10px 40px;
			box-sizing: border-box;
			.floor-first{
				display: block;
				text-align: center;
			}
			.copyright{
				padding-top: 0 !important;
				word-break: break-all;
				width: auto !important;
				box-sizing: border-box;
			}
		}
	}
</style>